'use strict'

class StationSettingsModelCtrl {
    constructor (datamodel, $mdDialog, $mdToast, $rootScope, $scope, $state, $stateParams, $cacheFactory, $http, $transitions) {
        this.datamodel = datamodel
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.$rootScope = $rootScope
        this.$scope = $scope
        this.$state = $state
        this.$stateParams = $stateParams
        this.$http = $http

        this.models = null
        this.banned = ['Twitter', 'Facebook']
        this.userWasWarned = false

        this.datamodel.isReady.then(this.fetch.bind(this))
        this.$rootScope.saveHiden = false
        this.$rootScope.saveDisabled = false
        this.$rootScope.saving = false
        this.$rootScope.save = this.save.bind(this)

        this.$httpCache = $cacheFactory.get('$http')
        //  this.$state.go('stationsettings.datamodel');

        this.unregisterStateChangeStart = $transitions.onStart({}, this.stateChangeStart.bind(this))

        $scope.$on('$destroy', () => {
            this.unregisterStateChangeStart()
        })

        //Configurate ui-sortable
        this.modelTypeSortableOptions = {

            axis: 'y',
            opacity: 0.6,
            stop: (e, ui) => {

                this.models.map((type, i) => {
                    type.order = i
                    return type
                })
            }
        }
    }

    fetch () {

        //check the param to know which model we need to use
        let validModels = [
            'broadcast',
            'campaign',
            'contact',
            'external',
            'item',
            'presenter',
            'program',
        ]

        if (validModels.indexOf(this.$stateParams.modelName) > -1) {
            this.$scope.$apply(() => {
                this.modelName = this.$stateParams.modelName
                this.models = this.datamodel.data[this.modelName]
            })
        }
    }

    checkActiveType (id) {
        return this.$state.params.typeId == id
    }

    openType (type) {
        this.$state.go('stationsettings.datamodel.type', { typeId: type.id })
    }

    shouldBeOpen (type) {
        return this.$state.current.name.indexOf(type) > -1
    }

    stateChangeStart (transition) {

        let to = transition.to()
        let toParams = transition.params()

        // If the state is not in the datamodel and the user was not yet warned
        if (to.name.indexOf('datamodel') < 0) {

            if (this.userWasWarned) {
                this.userWasWarned = false
            } else {

                // If the datamodel is dirty
                if (this.datamodel.isDirty()) {

                    transition.abort()

                    // If the fields are not valid
                    if (!this.$rootScope.saveDisabled) {
                        // Default action
                        let shouldSave = false

                        // Give me the option to save or leave without saving
                        this.$mdDialog.show({
                            controller: 'ConfirmDialogCtrl',
                            templateUrl: 'confirmDialog.ngTemplate',
                            parent: angular.element(document.querySelector('#popupContainer')),
                        })
                            .then(() => {
                                // Set shouldSave to true
                                shouldSave = true
                            })
                            .catch(() => {})
                            .finally(() => {

                                // Give the controller that the user is already warned
                                this.userWasWarned = true

                                // Check if you want to save or leave without
                                console.log('Shoul save the datamodel', shouldSave)
                                console.log(angular.copy(this.datamodel.data))
                                if (shouldSave) {
                                    this.save(true)
                                } else {
                                    this.datamodel.resetData()
                                }

                                // Proceed to the event state

                                this.$state.go(to, toParams)
                            })
                    }
                }
            }
        }
    }

    newType () {
        let newId = this.datamodel.generateId()
        let newType = {
            id: newId,
            name: '',
            model: this.modelName,
            options: {
                color: this.datamodel.colors[0][0],
            },
            fields: []
        }

        if (this.modelName == 'item') {
            newType.options.talk = false
            newType.options.hidden = false
        } else if (this.modelName == 'external') {
            newType.options.foreground = '#ffffff'
            newType.options.icons = this.datamodel.icons[0][0]
        }

        let index = this.models.push(newType)
        newType.order = index - 1

        this.$state.go('stationsettings.datamodel.type', { typeId: newId })
    }

    remove (ev, index) {

        ev.preventDefault()

        // Don't allow twitter or facebook external model to be deleted
        if (this.models[index].model == 'external' && this.banned.indexOf(this.models[index].name) > -1) {
            return false
        }

        this.$http.post('deletewarning', { model: 'model_type', id: this.models[index].id }).then((response) => {
            this.$mdDialog.show({
                controller: 'ConfirmManyDialogCtrl',
                templateUrl: 'confirmManyDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true,
                locals: {
                    count: response.data,
                    option: null
                }
            }).then(() => {

                //Remove type from model
                this.models.splice(index, 1)

                this.save()

                //Return to basis if needed
                if (this.$state.current.name != 'stationsettings.datamodel') {
                    this.$state.go('stationsettings.datamodel', { modelName: this.$stateParams.modelName })
                }
            })
        })

    }

    save (popup) {
        this.datamodel.save().then(response => {
            this.datamodel.data = response.data
            this.models = response.data[this.modelName]

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.saved?object=stationsettings&title=' + 'databuilder', //@trans('labels.settings')
                hideDelay: 6000,
                position: ('top right')
            })

            //Clear cached Template
            this.$httpCache.removeAll()
            this.userWasWarned = true

            if (!popup) {
                this.$state.go('stationsettings.datamodel')
            }
        })
    }
}

StationSettingsModelCtrl.$inject = [
    'datamodel',
    '$mdDialog',
    '$mdToast',
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    '$http',
    '$transitions'
]

module.exports = StationSettingsModelCtrl
